<template>
  <div>
    <data-table ref="dataTable" :option="option">
      <template #headAction>
        <a-button type="primary" class="ml" @click="copy">复制</a-button>
      </template>
      <span slot="ifHourRoom" slot-scope="test">
        <a-badge v-if="test" status="success" text="是" />
        <a-badge v-else status="error" text="否" />
      </span>
      <span slot="ifDefault" slot-scope="test">
        <a-badge v-if="test" status="success" text="是" />
        <a-badge v-else status="error" text="否" />
      </span>
      <template slot="rowAction" slot-scope="text, record">
        <a-button type="link" size="small" @click="editInfo(text)"
          >编辑</a-button
        >
        <a-divider type="vertical" />
        <a-popconfirm
          placement="bottomRight"
          title="您确认删除吗？"
          okText="确认"
          cancelText="取消"
          @confirm="delInfo({ Id: text })"
        >
          <a-button type="link" size="small">删除</a-button>
        </a-popconfirm>
        <a-divider type="vertical" />
        <a-button type="link" @click="checkCanlendar(record)" size="small"
          >房价日历</a-button
        >
      </template>
    </data-table>
    <Add ref="addRoomPrice" :title="title" />
    <PriceCalendar ref="PriceCalendar"></PriceCalendar>
    <a-modal
      title="折扣"
      :visible="visible"
      :maskClosable="false"
      @ok="submitCopy"
      @cancel="visible = false"
    >
      <div style="padding:10px 30px">
        折扣：<a-input-number
          v-model="discount"
          :min="0"
          style="width:150px"
        ></a-input-number>
        折
      </div>
    </a-modal>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import Add from "./AddRoomPrice/AddRoomPrice";
import PriceCalendar from "./PriceCalendar";
export default {
  name: "priceSystem",
  components: {
    DataTable,
    Add,
    PriceCalendar
  },
  data() {
    return {
      title: "",
      discount: 0,
      visible: false,
      selectRow: {}
    };
  },
  created() {
    this.option = {
      headSearch: {},
      form: {
        add: {
          onOpenBefore: () => {
            this.title = "新增房价";
            this.$refs.addRoomPrice.Show(1, "", false);
            return false;
          }
        },
        edit: {
          onOpenBefore: Id => {
            this.title = "修改房价";
            this.$refs.addRoomPrice.Show(2, Id, false);
            return false;
          }
        },
        del: {
          submitApi: "PriceSystem_Del"
        }
      },
      grid: {
        api: "PriceSystem_GetPageList",

        columns: [
          {
            title: "序号",
            width: "80px",
            type: "indexcolumn"
          },
          {
            title: "代码",
            width: "10%",
            dataIndex: "Code"
          },
          {
            title: "名称",
            width: "10%",
            dataIndex: "Name"
          },
          {
            title: "状态",
            width: "6%",
            dataIndex: "ValidStatus",
            // eslint-disable-next-line no-unused-vars
            customRender: (text, record, index) => {
              if (text) {
                return <a-badge status="success" text="启用" />;
              } else {
                return <a-badge status="error" text="禁用" />;
              }
            }
          },
          {
            title: "钟点房",
            width: "6%",
            dataIndex: "IsHourRoom",
            scopedSlots: { customRender: "ifHourRoom" }
          },
          {
            title: "默认价类",
            width: "7%",
            dataIndex: "IsDefault",
            scopedSlots: { customRender: "ifDefault" }
          },
          {
            title: "客户专用",
            width: "6%",
            dataIndex: "IsCustomerUse",
            customRender: text => {
              if (text) {
                return <a-badge status="success" text="是" />;
              } else {
                return <a-badge status="error" text="否" />;
              }
            }
          },
          {
            title: "会员专用",
            width: "6%",
            dataIndex: "IsMemberUse",
            customRender: text => {
              if (text) {
                return <a-badge status="success" text="是" />;
              } else {
                return <a-badge status="error" text="否" />;
              }
            }
          },
          {
            title: "可用开始时间",
            width: "8%",
            dataIndex: "OffStartTime"
          },
          {
            title: "可用结束时间",
            width: "8%",
            dataIndex: "OffEndTime"
          },
          {
            title: "说明",
            dataIndex: "Remark"
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: "220px",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  methods: {
    copy() {
      const row = this.$refs.dataTable.getSelected();
      if (row) {
        this.selectRow = row;
        this.discount = 0;
        this.visible = true;
      } else {
        this.$message.info("请先选择需要复制的价类");
      }
    },
    submitCopy() {
      this.$post("PriceSystem_Copy", {
        Id: this.selectRow.Id,
        Discount: this.discount
      }).then(res => {
        this.$message.success("复制成功");
        this.visible = false;
        // this.reload();
        this.title = "复制新增房价";
        this.$refs.addRoomPrice.Show(3, "", false, res.Data);
      });
    },
    reload() {
      this.$refs.dataTable.$refs.dataGrid.reload();
    },
    editInfo(id) {
      this.$refs.dataTable.edit(id);
    },
    delInfo(id) {
      this.$refs.dataTable.del(id);
    },
    checkCanlendar(record) {
      this.$refs.PriceCalendar.show(record);
    }
  }
};
</script>

<style lang="less" scoped></style>
